<nav class="nav-left" aria-label="Meniu principal">
  @for (element of meniu(); track element.id) {
    <app-nav-element [element]="element" />
  }
</nav>
